import { Logger } from "@feature-hub/core";
import {
  BffLoggerCall,
  BffLoggerCallLevel,
} from "@volkswagen-onehub/vw-starter-types-support";

const logPrefixes: { readonly [level in BffLoggerCallLevel]: string } = {
  error: "BFF Error:",
  warn: "BFF Warning:",
};

/**
 * log all log events sent with the BFF call in the feature app
 * @param appName
 * @param bffLoggerCalls
 * @param logger
 */
export function logBffLoggerCalls(
  appName: string,
  bffLoggerCalls: BffLoggerCall[],
  logger: Logger
): void {
  for (const call of bffLoggerCalls) {
    logger.debug(appName, logPrefixes[call.level], ...call.args);
  }
}
